import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const statDpiStockLocaleModule: LocaleModule = {
  name: "statDpiStock",
  messages: { en: en, it: it },
};
